import { render, staticRenderFns } from "./SingaporeMaps.vue?vue&type=template&id=4dd196c4&scoped=true&"
import script from "./SingaporeMaps.vue?vue&type=script&lang=js&"
export * from "./SingaporeMaps.vue?vue&type=script&lang=js&"
import style0 from "./SingaporeMaps.vue?vue&type=style&index=0&id=4dd196c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd196c4",
  null
  
)

export default component.exports